import { SendOutlined, UploadOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import React from 'react'
import { CensusUploadJobAction } from '../api/dto/census-upload-job.dto'

const ACTION_TAG: Record<
  CensusUploadJobAction,
  { label: string; color: string; icon: React.ReactNode }
> = {
  UPLOAD: { label: 'Upload', color: 'blue', icon: <UploadOutlined /> },
  SUBMIT: { label: 'Submit', color: 'green', icon: <SendOutlined /> },
}

// Icon and colour so an upload and a submit for the same file read apart at a glance
function CensusQueueActionTag({ action }: { action: CensusUploadJobAction }) {
  const { label, color, icon } = ACTION_TAG[action]
  return (
    <Tag color={color} icon={icon} style={{ marginInlineEnd: 0 }}>
      {label}
    </Tag>
  )
}

export default CensusQueueActionTag
